<div class="overlay-container">
    <div class="overlay-page"></div>
</div>